/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineObject21
 */
export interface InlineObject21 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject21
     */
    aktid: number;
    /**
     * 
     * @type {string}
     * @memberof InlineObject21
     */
    comment: string;
}

export function InlineObject21FromJSON(json: any): InlineObject21 {
    return InlineObject21FromJSONTyped(json, false);
}

export function InlineObject21FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineObject21 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aktid': json['aktid'],
        'comment': json['comment'],
    };
}

export function InlineObject21ToJSON(value?: InlineObject21 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aktid': value.aktid,
        'comment': value.comment,
    };
}


